import { render, staticRenderFns } from "./StakeNav.vue?vue&type=template&id=05a78860&scoped=true&"
import script from "./StakeNav.vue?vue&type=script&lang=ts&"
export * from "./StakeNav.vue?vue&type=script&lang=ts&"
import style0 from "./StakeNav.vue?vue&type=style&index=0&id=05a78860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a78860",
  null
  
)

export default component.exports